import React, { useState, useEffect, useRef, useCallback } from "react";
import "./NavigationBar.css";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../contexts/JWTAuthContext";
import { FaUser, FaUserPlus, FaSignOutAlt, FaTachometerAlt, FaChevronDown } from "react-icons/fa";
import { IoListSharp } from "react-icons/io5";
import { IoMdLogIn } from "react-icons/io";
import logo from "../../Assets/Images/logo.webp";

function NavigationBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { isAuthenticated, user, logout } = useAuth();

  const switchLanguage = () => {
    const next = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(next);
    try {
      document.documentElement.setAttribute("lang", next);
      document.documentElement.setAttribute("dir", next === "ar" ? "rtl" : "ltr");
    } catch (_) {}
  };

  let pages = useRef([
    { name: "Home", route: "/" },
    // { name: "Dashboard", route: "/dashboard" },
    // { name: "Listinings", route: "/listinings" },
    // { name: "Our Team", route: "/our-team" },
    // { name: "Gallery", route: "/gallery" },
    // { name: "Contact Us", route: "/contact-us" },
  ]);
  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight,
  });

  const setDimension = useCallback(() => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight,
    });
  }, [window]);

  const getRoutes = useCallback(() => {
    const matchedRoute = pages.current.find(
      (ele) => location.pathname === ele.route
    );
    return matchedRoute || { route: "" }; // Return a default object if no match is found
  }, [location.pathname]);

  useEffect(() => {
    window.addEventListener("resize", setDimension);

    return () => {
      window.removeEventListener("resize", setDimension);
    };
  }, [screenSize]);
  useEffect(() => {
    console.log();
  }, [location.pathname]);

  let [addclass, setaddclass] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/");
  };
console.log(user)
  return (
    <nav
      className={" NavbarDraw "}
      style={{
        position: screenSize.dynamicWidth < 1000 ? "" : "absolute",
        backgroundColor: "transparent",
      }}
      id="mynav"
    >
      <div className="mainclass container">
        <div className="Logo-size" style={{ cursor: "pointer" }}>
          <div onClick={() => navigate("/")} className="logo-icon">
            <img src={logo} width={"100%"} height={"100%"} />
          </div>
        </div>
        <ul className="Horizontal-list">
          {pages.current.map((ele) => (
            <li
              key={ele.route}
              className={getRoutes().route === ele.route ? "active-page" : ""}
            >
              <Link className="Horizontal-list-elements" to={ele.route}>
                {t(ele.name)}
              </Link>
            </li>
          ))}

          {}

          <li>
            <button
              type="button"
              onClick={switchLanguage}
              className="Horizontal-list-elements"
              style={{ background: "none", border: "none", cursor: "pointer" }}
              title={t("Language")}
            >
              {i18n.language === "ar" ? "English" : "العربية"}
            </button>
          </li>

          {isAuthenticated ? (
            <>
            <li className="nav-item dropdown">
            <Link className="Horizontal-list-elements" to="/dashboard">
                {t("Dashboard")}
              </Link>
            </li>
            <li className="nav-item dropdown">
            <Link className="Horizontal-list-elements" onClick={handleLogout}>{t("Log Out")}</Link>
            </li>


              {/* <li>
                <span className="Horizontal-list-elements user-name">
                  {user?.firstName || "User"}
                </span>
              </li> */}
<li className="nav-item dropdown">
            {/* <div className="Horizontal-list-elements dropdown-trigger">
              More <FaChevronDown style={{ fontSize: "12px", marginLeft: "5px" }} />
            </div>
            <div className="dropdown-content">
              <Link to="/dashboard">Dashboard</Link>
              <Link to="/orientations-listings">Orientations</Link>
              <Link to="/reservations-listings">Reservations</Link>
              <Link onClick={handleLogout}>Log Out</Link>
            </div> */}
          </li>
            </>
          ) : (
            <>
              <li>
                <Link
                  className="Horizontal-list-elements"
                  to="/login"
                  title={t("Login")}
                >
                  <IoMdLogIn /> {t("Login")}
                </Link>
              </li>
              <li>
                <Link
                  className="Horizontal-list-elements"
                  to="/register"
                  title={t("Register")}
                >
                  <FaUserPlus /> {t("Register")}
                </Link>
              </li>
            </>
          )}
        </ul>
        <input
          style={{ display: "none" }}
          id="check02"
          type="checkbox"
          name="menu"
        />
        <div
          style={{ width: "60px" }}
          className="collabse-button"
          onClick={() => {
            document.getElementById("mynav").classList.toggle("transition");
            document
              .getElementById("displayedlist")
              .classList.toggle("transition-list");
            document.getElementById("touch").classList.toggle("collapsed");
          }}
        >
          <button
            className="navbar-toggler collapsed"
            type="button"
            id="touch"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="toggler-icon top-bar"></span>
            <span className="toggler-icon middle-bar"></span>
            <span className="toggler-icon bottom-bar"></span>
          </button>
        </div>
      </div>
      <div>
        <ul className="DropDownList2" id={"displayedlist"}>
        <li>
                <span className="user-name">{user?.Name || ""}</span>
              </li>
          {pages.current.map((ele) => (
            <li
              key={ele.route}
              className={getRoutes().route === ele.route ? "active-page" : ""}
            >
              <Link to={ele.route}>{t(ele.name)}</Link>
            </li>
          ))}
          <li>
            <button
              type="button"
              className="logout-button"
              onClick={switchLanguage}
              title={t("Language")}
            >
              {i18n.language === "ar" ? "English" : "العربية"}
            </button>
          </li>
          {isAuthenticated ? (
            <>

              <li>
                <Link to="/dashboard" className="auth-icon" title={t("Dashboard")}>
                  {t("Dashboard")}
                </Link>
              </li>
              <li>
                <button className="logout-button" onClick={handleLogout}>
                  {t("Log Out")}
                </button>
              </li>
            </>
          ) : (
            <>
              <li>
                <Link to="/login" className="auth-icon" title={t("Login")}>
                  {t("Login")}
                </Link>
              </li>
              <li>
                <Link to="/register" className="auth-icon" title={t("Register")}>
                  {t("Register")}
                </Link>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
}

export default NavigationBar;
